import { ScreenSize } from '@/components/Common/Device';
import { useWindowSize } from 'usehooks-ts';

export const useDeviceType = () => {
  const { width: windowWidth } = useWindowSize();
  const isMobile = windowWidth <= ScreenSize.mobile;
  return { isMobile: isMobile };
};
